export const PridobivanjeVklopljenoNaroceno = {
  methods: {
    GetVklopljeneStoritve (prenParametri) {
      let manjkaIdVrsta = false
      if (prenParametri.prenesenIzbranId !== '' && prenParametri.prenesenIzbranId !== null && prenParametri.idVrsta !== undefined) {
        let param = ['idPrikljucek=' + prenParametri.prenesenIzbranId]
        for (let i = 0; i < prenParametri.idVrsta.length; i++) {
          if (typeof prenParametri.idVrsta[i] !== 'undefined') {
            param.push(('idVrsta[]=' + prenParametri.idVrsta[i]))
          } else {
            manjkaIdVrsta = true
          }
        }
        param.push('idStatus=' + prenParametri.idStatusVklopljeno)
        if (!manjkaIdVrsta) {
          this.clientAgent.postWsRequest(
            this,
            'prikljucek/storitve/info',
            param,
            prenParametri,
            'SetVklopljeneStoritve',
            'ErrVklopljeneStoritve')
        }
      }
    },
    SetVklopljeneStoritve (podatki, prenParametri) {
      let seznamVklopljenih = []
      let seznamVklopljenihStoritev = podatki.seznamStoritev
      for (let i = 0; i < seznamVklopljenihStoritev.length; i++) {
        seznamVklopljenih.push(seznamVklopljenihStoritev[i])
      }
      let vmesnik = prenParametri.vmesnik
      vmesnik.SetSeznamVkloplenihStoritev(prenParametri, seznamVklopljenih)
      if (typeof vmesnik['KliciMetodeSSeznama'] === 'function') {
        vmesnik.KliciMetodeSSeznama(prenParametri)
      }
    },
    ErrVklopljeneStoritve (podatki) {
      this.ShowWarningMessage(podatki)
    },
    GetNaroceneStoritve (prenParametri) {
      let manjkaIdVrsta = false
      if (prenParametri.prenesenIzbranId !== '' && prenParametri.prenesenIzbranId !== null && prenParametri.idVrsta !== undefined) {
        let param = ['idPrikljucek=' + prenParametri.prenesenIzbranId]
        for (let i = 0; i < prenParametri.idVrsta.length; i++) {
          if (typeof prenParametri.idVrsta[i] !== 'undefined') {
            param.push(('idVrsta[]=' + prenParametri.idVrsta[i]))
          } else {
            manjkaIdVrsta = true
          }
        }
        param.push('idStatus=' + prenParametri.idStatusNaroceno)
        if (!manjkaIdVrsta) {
          this.clientAgent.postWsRequest(
            this,
            'prikljucek/storitve/info',
            param,
            prenParametri,
            'SetTrenutnoNaroceneStoritve',
            'ErrTrenutnoNaroceneStoritve')
        }
      }
    },
    SetTrenutnoNaroceneStoritve (podatki, prenParametri) {
      let seznamNarocenih = []
      let seznamNarocenihStoritev = podatki.seznamStoritev
      for (let i = 0; i < seznamNarocenihStoritev.length; i++) {
        seznamNarocenih.push(seznamNarocenihStoritev[i])
      }
      let vmesnik = prenParametri.vmesnik
      vmesnik.SetSeznamNarocenihStoritev(prenParametri, seznamNarocenih)
      if (typeof vmesnik['KliciMetodeSSeznama'] === 'function') {
        vmesnik.KliciMetodeSSeznama(prenParametri)
      }
    },
    ErrTrenutnoNaroceneStoritve (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/NarociTelevizija/GetNarocenoVklopljeno.js